import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Wallet({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Wallet.Outline {...props} /> : <Wallet.Solid {...props} />;
}

Wallet.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.48356 3.75C4.48001 3.75 2.75 5.39296 2.75 8.33786V15.6543C2.75 18.5992 4.48001 20.25 7.48356 20.25H16.5173C19.5207 20.25 21.25 18.5994 21.25 15.6543V15.3484H17.7618C16.1901 15.3458 14.9384 14.1731 14.9411 11.8566C14.9447 10.3394 16.1952 9.12857 17.7618 9.12513H21.2464V8.33786C21.2464 5.39296 19.5165 3.75 16.5138 3.75H7.48356ZM21.25 10.6251H17.7618C16.9926 10.6285 16.4447 11.1403 16.4411 11.8566C16.4385 12.5803 16.9889 13.0967 17.7618 13.0984H21.25V10.6251ZM6.73932 7.62492C6.73474 7.62492 6.73016 7.62494 6.72558 7.62498C6.30689 7.62848 5.97177 7.97033 5.97755 8.3931C5.98347 8.81493 6.32927 9.12079 6.74869 9.11732L12.3829 9.11233C12.3875 9.11237 12.3922 9.11239 12.3968 9.11239C12.8151 9.10888 13.1502 8.7669 13.1444 8.34425C13.1384 7.92254 12.7928 7.61656 12.3735 7.61991L6.73932 7.62492Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <circle
          cx="18"
          cy="11.9004"
          r="1"
          stroke="currentColor"
          strokeWidth="1"
          fill="none"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Wallet.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For solid icons, be sure to add `className="icon-primary"`
         * and `className="icon-secondary"` to show the two-tone
         * aspect of the icon if necessary.
         */}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9964 8.37513H17.7618C15.7911 8.37859 14.1947 9.93514 14.1911 11.8566C14.1884 13.7823 15.7867 15.3458 17.7618 15.3484H22V15.6543C22 19.0136 19.9636 21 16.5173 21H7.48356C4.03644 21 2 19.0136 2 15.6543V8.33786C2 4.97862 4.03644 3 7.48356 3H16.5138C19.96 3 21.9964 4.97862 21.9964 8.33786V8.37513ZM6.73956 8.36733H12.3796H12.3831H12.3902C12.8124 8.36559 13.1538 8.03019 13.152 7.61765C13.1502 7.20598 12.8053 6.87318 12.3831 6.87491H6.73956C6.32 6.87664 5.97956 7.20858 5.97778 7.61852C5.976 8.03019 6.31733 8.36559 6.73956 8.36733Z"
          className="icon-primary"
        />
        <path
          opacity="0.4"
          d="M16.0374 12.2971C16.2465 13.2482 17.0805 13.9175 18.0326 13.9001H21.2825C21.6787 13.9001 22 13.572 22 13.1664V10.6349C21.9991 10.2302 21.6787 9.90126 21.2825 9.90039H17.9561C16.8731 9.90387 15.9983 10.8028 16 11.9107C16 12.0403 16.0128 12.17 16.0374 12.2971Z"
          className="icon-primary"
        />
        <circle cx="18" cy="11.9004" r="1" className="icon-primary" />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
